import { ExtractDocumentTypeFromTypedRxJsonSchema, RxJsonSchema, toTypedRxJsonSchema } from 'rxdb';

import { pendingReviewSchemaProperty } from './pending-review';

const noteSchemaLiteral = {
  title: 'note schema',
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      maxLength: 36,
      type: 'string',
    },
    userId: { type: 'string' },

    templateId: {
      type: ['string', 'null'],
      ref: 'notes', // self-reference
      default: null,
    },
    content: { type: 'string' },
    parsedContent: { type: 'string' }, // used to display content without HTML tags
    numTokens: { type: 'number' }, // token count for name+content
    name: { type: 'string' },
    templates: { type: 'array' },
    variant: { type: 'string' }, // "notes" | "templates"
    instructions: {
      type: 'object',
      // map of instruction.id to enabled boolean
      additionalProperties: { type: 'boolean' },
    },
    blockInstructions: {
      type: 'object',
      // map of blockId to object with instructionId to boolean mapping
      additionalProperties: {
        type: 'object',
        additionalProperties: { type: 'boolean' },
      },
    },

    userSources: {
      type: 'object',
      // map of userSource.id to object with enabled status and index
      additionalProperties: {
        properties: {
          enabled: { type: 'boolean' },
          index: { type: 'number' },
        },
        required: ['enabled', 'index'],
        type: 'object',
      },
    },

    aliases: {
      type: 'array',
      items: { type: 'string' },
    },
    tagIds: {
      type: 'array',
      items: { type: 'string' },
    },
    blockIds: {
      type: 'array',
      items: { type: 'string' },
    },

    classificationCache: {
      type: ['object', 'null'],
      properties: {
        contentHash: { type: 'string' },
        classification: { type: 'object', additionalProperties: true },
      },
      required: ['contentHash', 'classification'],
      default: null,
    },
    pendingReview: pendingReviewSchemaProperty,

    createdAt: { type: 'string' },
    updatedAt: { type: 'string' },
    archivedAt: { type: ['string', 'null'] },
    archived: { type: 'boolean' },
  },
  required: [
    'id',
    'userId',
    'content',
    'parsedContent',
    'name',
    'variant',
    'instructions',
    'blockInstructions',
    'userSources',
    'aliases',
    'tagIds',
    'createdAt',
    'updatedAt',
    'archived',
  ],
  indexes: [['archived']],
} as const;
const _noteSchemaTyped = toTypedRxJsonSchema(noteSchemaLiteral);

export type Note = ExtractDocumentTypeFromTypedRxJsonSchema<typeof _noteSchemaTyped>;
export const noteSchema: RxJsonSchema<Note> = noteSchemaLiteral;
